/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const PinPersonIconOutline = createIcon({
  displayName: 'PinPersonIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <circle
        cx="11.7"
        cy="3.5"
        r="1.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      ></circle>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M11 16h1.6c.6 0 1-.4 1-1v-2.75l1-1.2c.1-.2.2-.4.2-.6v-2.2c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v2.2c0 .2.1.4.2.6l1 1.2v2.75c1.77636e-15.6.4 1 1 1Z"
      ></path>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M18 13.704c1.836.639 3 1.562 3 2.596 0 1.472-2.34 2.73-5.65 3.247"
      ></path>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6 13.704c-1.836.639-3 1.562-3 2.596 0 1.933 4.029 3.5 9 3.5"
      ></path>
    </>
  ),
})

const PinPersonIconTwoTone = createIcon({
  displayName: 'PinPersonIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="circle"
        cx="11.7"
        cy="3.5"
        r="1.5"
        stroke="twoToneStrokeColor"
        fill="primary"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="path"
        stroke="twoToneStrokeColor"
        fill="primary"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M11 16h1.6c.6 0 1-.4 1-1v-2.75l1-1.2c.1-.2.2-.4.2-.6v-2.2c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v2.2c0 .2.1.4.2.6l1 1.2v2.75c1.77636e-15.6.4 1 1 1Z"
      />
      <Box
        as="path"
        fill="none"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M18 13.704c1.836.639 3 1.562 3 2.596 0 1.472-2.34 2.73-5.65 3.247"
      />
      <Box
        as="path"
        fill="none"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6 13.704c-1.836.639-3 1.562-3 2.596 0 1.933 4.029 3.5 9 3.5"
      />
    </>
  ),
})

const PinPerson: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    case 'twoTone':
      return <CustomIcon as={PinPersonIconTwoTone} {...props} />
    default:
      return <CustomIcon as={PinPersonIconOutline} {...props} />
  }
}

export default memo(PinPerson)
